/**
 * @generated SignedSource<<1de7d5361a6ea6f892b570e4febbc125>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_businessList_ListViewWithWorkflow_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"IssueCreateProvider">;
  readonly " $fragmentType": "src_businessList_ListViewWithWorkflow_queryFragment";
};
export type src_businessList_ListViewWithWorkflow_queryFragment$key = {
  readonly " $data"?: src_businessList_ListViewWithWorkflow_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_ListViewWithWorkflow_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_businessList_ListViewWithWorkflow_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "IssueCreateProvider"
    }
  ],
  "type": "Query"
};

(node as any).hash = "f2ef167d11fdd3f2601fe9d2916e6c35";

export default node;
